import { Api } from './index';

export const fetchSweeps = () => Api.get('/sweepstakes');

export const postEntries = (data) => Api.post('/orders/sweepstakes', data);
